module.exports = __webpack_public_path__ + "static/media/laptop_icon.91479ea8.jpg";